export var US_COUNTRY_CODE = 'US';
export var ApolloFetchPolicy = /*#__PURE__*/function (ApolloFetchPolicy) {
  ApolloFetchPolicy["CACHE_FIRST"] = "cache-first";
  ApolloFetchPolicy["CACHE_ONLY"] = "cache-only";
  ApolloFetchPolicy["CACHE_AND_NETWORK"] = "cache-and-network";
  ApolloFetchPolicy["NETWORK_ONLY"] = "network-only";
  ApolloFetchPolicy["NO_CACHE"] = "no-cache";
  ApolloFetchPolicy["STANDBY"] = "standby";
  return ApolloFetchPolicy;
}({});
export var ApolloErrorPolicy = /*#__PURE__*/function (ApolloErrorPolicy) {
  ApolloErrorPolicy["ALL"] = "all";
  ApolloErrorPolicy["IGNORE"] = "ignore";
  ApolloErrorPolicy["NONE"] = "none";
  return ApolloErrorPolicy;
}({});

/**
 * Enum containing all team names
 */
export var TeamNames = /*#__PURE__*/function (TeamNames) {
  TeamNames["ADS"] = "ADS";
  TeamNames["GDH"] = "GDH";
  TeamNames["GDC"] = "GDC";
  TeamNames["SEARCH"] = "SEARCH";
  TeamNames["CAPP"] = "CAPP";
  TeamNames["CWF"] = "CWF";
  TeamNames["GDV"] = "GDV";
  TeamNames["USE"] = "USE";
  TeamNames["WT"] = "WT";
  TeamNames["HACKWORTH"] = "HACKWORTH";
  TeamNames["CSTBS"] = "CSTBS";
  TeamNames["CW"] = "CW";
  TeamNames["GROWTH_A"] = "GROWTH_A";
  TeamNames["CMW"] = "CMW";
  TeamNames["EXODIA"] = "EXODIA";
  TeamNames["MANDALORIANS"] = "MANDALORIANS";
  TeamNames["MYAC"] = "MYAC";
  TeamNames["MEMBERSHIP"] = "MEMBERSHIP";
  TeamNames["TITANS"] = "TITANS";
  TeamNames["PACMAN"] = "PACMAN";
  TeamNames["NITEHAWK"] = "NITEHAWK";
  return TeamNames;
}({});
export var Durations = {
  ONE_YEAR_IN_SECONDS: 31536000,
  FOUR_MONTHS_IN_SECONDS: 10368000,
  SEVEN_DAYS_IN_SECONDS: 604800
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/common/constants/index.js
// module id = 2869
// module chunks = 11